import { View, Text } from "react-native";
import React from "react";
import WhiteText from "components/WhiteText";

const index = () => {
  return (
    <View>
      <WhiteText style={{ fontSize: 22 }}>Wind Surge Access Member</WhiteText>
    </View>
  );
};

export default index;
